/**
 * <dogbook-breed-carousel> — horizontal snap scroller with prev/next arrows.
 * Progressive enhancement: the row scrolls natively without JS; the arrows
 * simply add click-to-scroll and disable at the ends. Lifecycle-safe.
 */
if (!customElements.get('dogbook-breed-carousel')) {
  class DogbookBreedCarousel extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-db-scroller]');
      this.prev = this.querySelector('[data-db-prev]');
      this.next = this.querySelector('[data-db-next]');
      if (!this.scroller) return;

      this.onPrev = () => this.scrollByDir(-1);
      this.onNext = () => this.scrollByDir(1);
      this.onScroll = () => this.updateArrows();

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.updateArrows();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.scroller?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByDir(dir) {
      this.scroller.scrollBy({
        left: dir * this.scroller.clientWidth * 0.6,
        behavior: 'smooth',
      });
    }

    updateArrows() {
      if (!this.prev || !this.next) return;
      const max = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
      const x = this.scroller.scrollLeft;
      this.prev.disabled = x <= 0;
      this.next.disabled = x >= max;
    }
  }

  customElements.define('dogbook-breed-carousel', DogbookBreedCarousel);
}
